import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step8: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "properties",
      label: "Seleccione los bienes que tiene en su hogar",
      questionData: questions[0],
      elementType: ElementType.Checkbox,
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 1.1rem",
        marginTop: "8px",
      },
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "techProperties",
      label: "Seleccione los bienes de tecnología que tiene en su hogar",
      questionData: questions[1],
      elementType: ElementType.Checkbox,
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 1.1rem",
        marginTop: "8px",
      },
    },
    {
      key: 2,
      formik,
      visible: true,
      type: "number",
      name: "computers",
      questionData: questions[2],
      elementType: ElementType.Textfield,
      label: "Cuántos computadores tiene en el hogar",
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "socialNetworks",
      label: "¿Qué redes utiliza?",
      questionData: questions[3],
      elementType: ElementType.Checkbox,
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1.1rem",
        marginTop: "8px",
      },
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos más sobre su entorno: Bienes y tecnología
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step8;
